<template>
  <!-- :key="resultId" -->
  <div
    class="item"
    :style="(!loading && type !== 'datasets' && windowWidth < 688) ? false : { height: (height + (type === 'pdfs' ? -16 : (isSlider ? 46 : 28))) + 'px' }"
    @mouseenter="hoveredItem = resultId"
    @mouseleave="hoveredItem = false"
  >
    <div
      v-if="loading"
      :class="['item__skeleton', 'item__skeleton--' + type, 'skeleton']"
    >
      <template v-if="type === 'datasets'">
        <div class="skeleton--center">
          <div class="skeleton__line h24 center" :style="{ width: (Math.floor(Math.random() * 25) + 65) + '%' }" />
          <div class="skeleton__chart" />
        </div>
      </template>

      <template v-if="type === 'pdfs'">
        <div class="skeleton--left flex1">
          <div class="skeleton__square"></div>
        </div>

        <div class="skeleton--right flex2">
          <div class="skeleton__line h17 w40 m10"></div>
          <div class="skeleton__line"></div>
          <div class="skeleton__line h8 w50"></div>
          <div class="skeleton__line w75"></div>
        </div>
      </template>
    </div>

    <div
      v-else
      :class="['item__content', 'item__content--' + type, selected ? 'item__content--selected' : '']"
    >
      <router-link
        :to="url"
        class="link--blank"
      >
        <div
          v-if="showRibbon"
          :class="['item__status', licensed && trial && !free && type === 'datasets' ? 'item__status--free' : (free ? 'item__status--free' : 'item__status--locked'), hoveredItem === resultId ? 'item__status--active' : '']"
        >
          <span v-html="licensed && trial && !free && type === 'datasets' ? 'Trial' : (free ? 'Free' : 'Premium')" />
        </div>

        <div
          v-if="!selected"
          :class="['item__button', hoveredItem === resultId ? 'item__button--active' : '']"
        >
          <span>{{ (licensed ? 'View ' : 'Preview ') + (type === 'datasets' ? 'Dataset' : 'PDF') }}</span>
        </div>

        <div
          v-else
          class="item__button item__button--active"
        >
          <span>SELECTED</span>
        </div>

        <div :class="['item__title', 'item__title--' + type, isSlider ? 'item__title--slider' : '', hoveredItem === resultId ? 'item__title--active' : '']">
          <p v-html="highlight(title, filterWords)" />
          <p v-html="highlight(title, filterWords)" />
        </div>

        <div
          v-if="type === 'datasets'"
          :class="['item__chart', isSlider ? 'item__chart--slider' : '']"
        >
          <ChartLite
            :resultId="resultId"
            :data="data"
            :licensed="licensed"
            :height="isSlider ? (height + 10) : (height - 16)"
          />
        </div>

        <div
          v-if="type === 'pdfs'"
          :class="['item__pdf', isSlider ? 'item__pdf--slider' : '']"
        >
          <UtilityItemPDF
            :result="result"
            :size="size"
            :height="height"
            :windowWidth="windowWidth"
          />
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import ChartLite from '@/components/chart/Lite.vue'
import UtilityItemPDF from '@/components/utility/ItemPDF.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    ChartLite,
    UtilityItemPDF
  },
  props: {
    result: {
      type: Object,
      default: function () {
        return {}
      }
    },
    resultId: {
      type: [Boolean, String],
      default: ''
    },
    url: {
      type: String,
      default: '#'
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'datasets'
    },
    size: {
      type: String,
      default: 'sm'
    },
    data: {
      type: Object
    },
    licensed: {
      type: Boolean,
      default: false
    },
    trial: {
      type: Boolean,
      default: false
    },
    free: {
      type: Boolean,
      default: false
    },
    isSlider: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String],
      default: ''
    },
    windowWidth: {
      type: [Number, String],
      default: ''
    },
    selected: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hoveredItem: false
    }
  },
  computed: {
    status () {
      return this.$store.getters['search/getStatus']
    },
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    userData () {
      return this.$store.getters['user/getData']
    },
    hasGlobalLicense () {
      let check = false

      if (this.userData && this.userData.licenses) {
        this.userData.licenses.forEach(license => {
          if (license.attributes.resource_type === 'global' && license.attributes.status === 'valid') {
            check = true
          }
        })
      }

      return check
    },
    showRibbon () {
      if (this.licensed === false || (this.licensed === true && this.trial === true)) {
        return true
      }

      return false
    },
    filterWords () {
      let words = []
      let getter = this.$store.getters['search/getSelectedFilters']

      Object.keys(getter).forEach(function (filters) {
        if (getter[filters] && getter[filters].length > 0) {
          getter[filters].forEach(function (filter) {
            words.push(filter.attributes.name)
          })
        }
      })

      return words
    }
  },
  methods: {
    clicked (value) {
      this.$emit('clicked', value)
    },
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.item {
  //background-color: $black;
  //background-color: $bg-4;
  //@include font('content--sm');
  display: flex;
  position: relative;
  width: 100%;
  text-align: center;
  //padding: 8px;

  /*&:hover {
    background-color: $bg-2;
  }*/

  &__skeleton {
    position: absolute;
    top: 8px;
    bottom: 8px;
    right: 8px;
    left: 8px;
    width: calc(100% - 16px);

    &--datasets {
      top: 16px;
      bottom: 16px;
      right: 16px;
      left: 16px;
      width: calc(100% - 32px);
    }

    /*&--pdfs {

    }*/
  }

  &__content {
    position: relative;
    width: 100%; //calc(100% - 16px);
    //padding: 8px;

    &--selected {
      //background-color: $bg-2;
    }
  }

  /*&__content:not(.item__content--datasets) {
    width: calc(100% - 16px);
    padding: 8px;
  }*/

  &__chart {
    width: calc(100% - 16px);
    padding: 0px 8px;

    &--slider {
      width: 100%;
      padding: 0px;
    }
  }

  &__pdf {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  &__title {
    @include font('content--sm', $white);
    flex: 1;
    position: relative;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--md', $white);
    }

    p:first-child {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      //width: calc(100% - 32px);
    }

    p:last-child {
      display: none;
      //margin: 0;
      pointer-events: none;
      user-select: none;
      //width: calc(100% - 32px);
    }

    &--active {
      p:last-child {
        width: calc(100% - 16px);
        display: -webkit-box;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 8;
        background: $bg-2;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
      }
    }

    &--datasets {
      height: 44px;
      text-align: center;

      p:first-child {
        //margin: 4px 16px 0px 16px;
        margin: 0px;
        padding: 4px 8px 0px 8px;
        -webkit-line-clamp: 2;
        line-clamp: 2;
      }

      p:last-child {
        //margin: 0px 16px 0px 16px;
        margin: 0px;
        padding: 4px 8px 0px 8px;
        -webkit-line-clamp: 6;
        line-clamp: 6;
      }
    }

    &--pdfs {
      height: 40px;
      text-align: left;

      p:first-child {
        margin: 0px;
        padding: 0px 8px;
        -webkit-line-clamp: 2;
        line-clamp: 2;
      }

      p:last-child {
        margin: 0px;
        padding: 0px 8px;
        -webkit-line-clamp: 5;
        line-clamp: 5;
      }
    }

    &--slider {
      //height: 24px;

      p:first-child {
        margin: 0px;
        padding: 0px 8px;
      }

      p:last-child {
        margin: 0px;
        padding: 0px 8px;
      }
    }
  }

  &__button {
    @include font('content--xs', $black);
    text-transform: uppercase;
    font-weight: 500;
    position: relative;
    height: 0px;
    top: calc(50% - 0.5rem);
    z-index: 9;
    opacity: 0;
    transform: scale(0.5);
    filter: drop-shadow(2px 3px 2px rgba(black, 0.5));
    transition: opacity 0.25s ease-out, transform 0.19s ease-out;

    &--active {
      cursor: pointer;
      transform: scale(1.0);
      opacity: 1;
    }

    span {
      background-color: $bg-5;
      border: 1px solid rgba($white, 0.5);
      padding: 0.6rem 1rem;
      border-radius: 3px;
      transition: border 0.2s ease-out, color 0.15s ease-out, background-color 0.2s ease-out;
    }
  }

  &__status {
    @include font('content--xxs', $white, 0.9);
    text-transform: uppercase;
    font-weight: 500;
    position: absolute;
    top: 3px;
    right: 3px;
    z-index: 9;
    border-radius: 99px;
    filter: drop-shadow(0px 0px 6px rgba($black, 0.1));
    transition: opacity 0.25s ease-out;

    @media screen and (min-width: $breakpointLg) {
      @include font('content--xs', $white, 0.9);
      text-transform: uppercase;
      font-weight: 500;
    }

    span {
      padding: 0 10px;
    }

    &--free {
      background-color: #336b19;
      border: 2px solid $bg-2;
      border-left: 2px solid $bg-2 !important;
    }

    &--locked {
      color: rgba($white, 0.7);
      background-color: $bg-2;
      border: 2px solid $bg-1;
      border-left: 2px solid $bg-1 !important;
    }

    &--active {
      opacity: 0;
    }
  }
}

.slider__item .item__status {
  top: -5px;
  right: -5px;
}

.skeleton {
  //width: 100%;
  //height: 100%;
  display: flex;
  align-items: center;

  &__chart {
    width: 100%;
    margin: 0 auto;
    height: 75%;
    border-radius: 4px;
    background: rgba(130, 130, 130, 0.2);
    background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
    background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
    background-size: 800px 100px;
    animation: wave-squares 2s infinite ease-out;
  }

  &__square {
    height: 64px;
    border-radius: 2px;
    background: rgba(130, 130, 130, 0.2);
    background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
    background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
    background-size: 800px 100px;
    animation: wave-squares 2s infinite ease-out;
  }

  &__line {
     height: 12px;
     margin-bottom:6px;
     border-radius: 2px;
     background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-lines 2s infinite ease-out;
  }

  &--right{
    flex: 1;
  }

  &--left{
    flex: 2;
    padding-right: 15px;
  }

  &--center {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    flex: 1;
  }
}

.flex1 {
  flex: 1;
}
.flex2 {
  flex: 2;
}
.skeleton--line:last-child {
  margin-bottom: 0;
}
.h8{
  height: 8px !important;
}
.h10{
  height: 10px !important;
}
.h12{
  height: 12px !important;
}
.h15{
  height: 15px !important;
}
.h16{
  height: 16px !important;
}
.h17{
  height: 17px !important;
}
.h20{
  height: 20px !important;
}
.h24{
  height: 24px !important;
}
.h25{
  height: 25px !important;
}
.h32{
  height: 32px !important;
}
.w25{
  width: 25% !important
}
.w40{
  width:40% !important;
}
.w50{
  width: 50% !important
}
.w75{
  width: 75% !important
}
.m10{
  margin-bottom: 10px !important;
}
.m16{
  margin-bottom: 16px !important;
}
.circle{
  border-radius: 50% !important;
  height: 80px !important;
  width: 80px;
}
.rotate {
  transform: rotate(90deg);
}
.center {
  margin-left: auto;
  margin-right: auto;
}

@keyframes wave-lines {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

@keyframes wave-squares {
  0% {
    background-position: -468px 0;
  }
  100% {
     background-position: 468px 0;
  }
}

</style>
